import { Button, Conditional } from '@payaca/ambrosia';

import { FC, PropsWithChildren } from 'react';

export interface IProps {
  onAdd?: () => void;
}

const FieldSetArrayOuterCard: FC<PropsWithChildren<IProps>> = (props) => {
  const { onAdd, children } = props;

  return (
    <div className="space-y-4">
      {children}

      <Conditional condition={!!onAdd}>
        <div>
          <Button onClick={onAdd} variant={'outline'} size={'sm'}>
            Add
          </Button>
        </div>
      </Conditional>
    </div>
  );
};

export default FieldSetArrayOuterCard;
